import { Link } from "react-router-dom";

export const CTASection = () => {
  return (
    <section className="py-28 bg-card relative overflow-hidden" aria-label="Start planning">
      {/* Decorative radial gold glow */}
      <div className="absolute inset-0 pointer-events-none" aria-hidden="true">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[300px] bg-gold/5 rounded-full blur-3xl" />
      </div>
      {/* Top + bottom gold line */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold/40 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold/20 to-transparent" />

      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-2xl mx-auto text-center">
          <div className="flex items-center justify-center gap-4 mb-7">
            <div className="h-px flex-1 max-w-[60px] bg-gradient-to-r from-transparent to-gold/40" />
            <p className="font-cinzel text-[0.6rem] text-gold tracking-[0.35em] uppercase">Ready to Begin</p>
            <div className="h-px flex-1 max-w-[60px] bg-gradient-to-l from-transparent to-gold/40" />
          </div>

          <h2 className="font-serif font-light text-foreground mb-6 leading-[1.1]"
              style={{ fontSize: "clamp(2rem, 4.5vw, 3.2rem)" }}>
            Ready to Stop Researching<br />
            and Start Planning?
          </h2>

          <p className="font-sans text-foreground/60 text-[1rem] leading-relaxed mb-4 max-w-lg mx-auto">
            A well-planned Disney trip is the difference between a vacation you survive and one your family talks about for years.
          </p>
          <p className="font-sans text-muted-foreground text-[0.875rem] mb-12 max-w-md mx-auto">
            Reach out to start a conversation. No obligation. No sales pitch. Just clarity.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="https://book.peacefullyeveraftertravel.com"
              className="inline-flex items-center justify-center font-cinzel text-[0.62rem] tracking-[0.25em] uppercase px-10 py-4 bg-gold hover:bg-[hsl(46,80%,60%)] text-[hsl(222,64%,10%)] rounded-[2px] shadow-gold transition-smooth"
            >
              Schedule a Consultation
            </a>
            <Link
              to="/work-with-me"
              className="inline-flex items-center justify-center font-cinzel text-[0.62rem] tracking-[0.25em] uppercase px-10 py-4 border border-gold/25 text-foreground/70 hover:text-foreground hover:border-gold/50 hover:bg-gold/5 rounded-[2px] transition-smooth"
            >
              See How It Works
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};
